var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3:236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.56093 3.19403H3.9714C3.54785 3.19403 3.14164 3.36229 2.84214 3.66178C2.54265 3.96128 2.37439 4.36749 2.37439 4.79104V15.9701C2.37439 16.3937 2.54265 16.7999 2.84214 17.0994C3.14164 17.3989 3.54785 17.5671 3.9714 17.5671H15.1505C15.574 17.5671 15.9802 17.3989 16.2797 17.0994C16.5792 16.7999 16.7475 16.3937 16.7475 15.9701V10.3806",
    stroke: "currentcolor",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5497 1.99628C15.8674 1.67861 16.2982 1.50015 16.7475 1.50015C17.1967 1.50015 17.6276 1.67861 17.9452 1.99628C18.2629 2.31394 18.4413 2.74479 18.4413 3.19404C18.4413 3.64328 18.2629 4.07413 17.9452 4.39179L10.3594 11.9776L7.16541 12.7761L7.96391 9.58207L15.5497 1.99628Z",
    stroke: "currentcolor",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3:236"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.1641,
    height: 19.1641,
    fill: "currentcolor",
    transform: "translate(0.777344)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.9e397b9e4a65d87f789ab83a55b5a49d.svg";
export { ForwardRef as ReactComponent };